import { ApiParameter, post, request, ServiceResult } from "@insite/client-framework/Services/ApiService";

export interface CareerApiParameter extends ApiParameter {
    careerForm: Partial<CareerFormApiModel>;
}

export interface CareerFormApiModel extends ApiParameter {
    FirstName: string;
    LastName: string;
    Address1: string;
    Address2: string;
    City: string;
    State: string;
    ZIP: string;
    Phone: string;
    Email: string;
    PositionDesired: string;
    HearAboutUs: string;
    Resume: any;
}
const customUrl = "/api/careers/sendemail";

// eslint-disable-next-line require-await
export async function careerService(parameter: CareerApiParameter): Promise<ServiceResult<CareerApiParameter>> {
    const data = {
        FirstName: parameter.careerForm.FirstName,
        LastName: parameter.careerForm.LastName,
        Address1: parameter.careerForm.Address1,
        Address2: parameter.careerForm.Address2,
        City: parameter.careerForm.City,
        State: parameter.careerForm.State,
        ZIP: parameter.careerForm.ZIP,
        Phone: parameter.careerForm.Phone,
        Email: parameter.careerForm.Email,
        PositionDesired: parameter.careerForm.PositionDesired,
        HearAboutUs: parameter.careerForm.HearAboutUs,
    };
    const formData = new FormData();
    formData.append("Resume", parameter.careerForm.Resume);
    formData.append("Data", JSON.stringify(data));
    return request<ServiceResult<CareerApiParameter>>(customUrl, "POST", {}, formData);
}
